import React, { useEffect } from "react";

import { Row, Col, Input, Pagination } from "antd";
import { Margin } from "styled-components-spacing";
import Center from "react-center";
import moment from "jalali-moment";

// CSS Files
import "../../../Fonts/Fonts.css";
import "../../../Statics/Common/FontStyle.css";
import "../../../Statics/InsuranceKnowledge/Books/Books.css";

const thTable = {
  direction: "rtl",
  textAlign: "center",
  fontSize: ".8em",
  color: "#8d8d8d",
  fontFamily: "IranSans",
  padding: "5px",
};
const tdPage = {
  direction: "rtl",
  textAlign: "center",
  padding: "10px",
  fontFamily: "IranSansUltraLight",
  fontSize: ".8em",
  borderRadius: "10px 0 0 10px",
  color: "#ed1e24",
};
const tdYear = {
  direction: "rtl",
  textAlign: "center",
  padding: "10px",
  fontFamily: "IranSansUltraLight",
  fontSize: ".8em",
  color: "#ed1e24",
};
const tdWriter = {
  direction: "rtl",
  textAlign: "center",
  padding: "10px",
  fontFamily: "IranSansLight",
  fontSize: ".8em",
  color: "#3d5563",
};
const tdPlace = {
  direction: "rtl",
  textAlign: "center",
  padding: "10px",
  fontFamily: "IranSans",
  fontSize: ".8em",
  color: "#8d8d8d",
};
const tdName = {
  direction: "rtl",
  textAlign: "center",
  fontFamily: "IranSansBold",
  fontSize: ".8em",
  borderRadius: "0 10px 10px 0",
  padding: "10px",
};

const ArticlesTable = (props) => {



  return props.size === "laptopdesktop" ? (
    <div>
      <table
        style={{
          fontFamily: "IranSans",
          borderCollapse: "separate",
          borderSpacing: "0 15px",
        }}
      >
        {props.articles.length > 0 ? (
          <tr>
            <th style={thTable}>تعداد صفحات</th>
            <th style={thTable}>سال انتشار</th>
            <th style={thTable}>مؤلف</th>
            <th style={thTable}>محل انتشار</th>
            <th style={thTable}>عنوان</th>
          </tr>
        ) : (
          ""
        )}

        {props.articles.map((item, index) => {
          return [
            <tr style={{ backgroundColor: "#fff" }} key={index}>
              <td style={tdPage}>{item.pages}</td>
              <td style={tdYear}>
                {item.publish_date}
              </td>
              <td style={tdWriter}>
                {item.writer}
              </td>
              <td style={tdPlace}>{item.publish_location}</td>
              <td style={tdName}>
                <a onClick={()=>props.history.push(`/articlesinside/${item.id}`)}>
                  <p style={{ color: "#253d4b", marginTop: "10px" }}>
                    <strong>{item.title}</strong>
                  </p>
                </a>
              </td>
            </tr>,
          ];
        })}
      </table>
    </div>
  ) : props.size === "tablet" ? (
      <div>
        <table
          style={{
            fontFamily: "IranSans",
            borderCollapse: "separate",
            borderSpacing: "0 15px",
          }}
        >
          {props.articles.length > 0 ? (
            <tr>
              <th style={thTable}>تعداد صفحات</th>
              <th style={thTable}>سال انتشار</th>
              <th style={thTable}>مؤلف</th>
              <th style={thTable}>محل انتشار</th>
              <th style={thTable}>عنوان</th>
            </tr>
          ) : (
              ""
            )}

          {props.articles.map((item, index) => {
            return [
              <tr style={{ backgroundColor: "#fff" }} key={index}>
                <td style={tdPage}>{item.pages}</td>
                <td style={tdYear}>
                  {item.publish_date}
                </td>
                <td style={tdWriter}>
                  {item.writer}
                </td>
                <td style={tdPlace}>{item.publish_location}</td>
                <td style={tdName}>
                  <a onClick={() => props.history.push(`/articlesinside/${item.id}`)}>
                    <p style={{ color: "#253d4b", marginTop: "10px" }}>
                      <strong>{item.title}</strong>
                    </p>
                  </a>
                </td>
              </tr>,
            ];
          })}
        </table>
      </div>
  ) : (
    <div>
          <table
            style={{
              fontFamily: "IranSans",
              borderCollapse: "separate",
              borderSpacing: "0 15px",
            }}
          >
            {props.articles.length > 0 ? (
              <tr>
                <th style={thTable}>تعداد صفحات</th>
                <th style={thTable}>سال انتشار</th>
                <th style={thTable}>مؤلف</th>
                <th style={thTable}>محل انتشار</th>
                <th style={thTable}>عنوان</th>
              </tr>
            ) : (
                ""
              )}

            {props.articles.map((item, index) => {
              return [
                <tr style={{ backgroundColor: "#fff" }} key={index}>
                  <td style={tdPage}>{item.pages}</td>
                  <td style={tdYear}>
                    {item.publish_date}
                  </td>
                  <td style={tdWriter}>
                    {item.writer}
                  </td>
                  <td style={tdPlace}>{item.publish_location}</td>
                  <td style={tdName}>
                    <a onClick={() => props.history.push(`/articlesinside/${item.id}`)}>
                      <p style={{ color: "#253d4b", marginTop: "10px" }}>
                        <strong>{item.title}</strong>
                      </p>
                    </a>
                  </td>
                </tr>,
              ];
            })}
          </table>
    </div>
  );
};

export default ArticlesTable;
